import {Injectable} from '@angular/core';
import {SimpleDataFilter} from '../../../models/simpleDataFilter';
import {UserSettingsService} from '../../../users-module/services/user-settings-service';
import {UserSetting} from '../../../users-module/models/userLight';
import {AuthService} from '../../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  public pageIncrements: any[] = [10, 30, 50, 100, 200];
  public offsetCount = 0;
  public currentPage = 1;
  public pageIncrement = 50; // SCRSTP-1834 : 50 records for everyone.. all the time

  private settingName = 'GridSettings';

  constructor(public auth: AuthService, private readonly userSettingsService: UserSettingsService) {
    // if(this.auth.UserInRole('paginator')) this.pageIncrement = 100;
  }

  public resetValues() {
    this.offsetCount = 0;
    this.currentPage = 1;
  }

  public getDefaultPageIncrementFilter(filters: SimpleDataFilter[]): SimpleDataFilter[] {

    if (!filters) {
      filters = new Array<SimpleDataFilter>();
    }

    // if (this.userSettingsService.userSettings) {
    //   // Do we have a pagination setting? If so, set our current variable
    //   const t = this.getPaginationIncrementSetting();

    //   if (t) {
    //     const setting = JSON.parse(t.settingsJSON);
    //     this.pageIncrement = setting.pageIncrement;
    //   }
    // }

    const existingFilter = filters.find((r: SimpleDataFilter) => r.key === 'fetchCount');

    if (existingFilter) {
      existingFilter.value = this.pageIncrement.toString();
    } else {
      filters.push(new SimpleDataFilter('fetchCount', this.pageIncrement.toString(), true));
    }

    return filters;

  }

  public setPageIncrement(pageSize: number): void {
    this.pageIncrement = pageSize;

    const t = {pageIncrement: pageSize.toString()};

    let setting = this.getPaginationIncrementSetting();

    if (setting) {
      setting.settingsJSON = JSON.stringify(t);
      this.userSettingsService.SaveUserSetting(setting, false);
    } else {
      setting = new UserSetting();
      setting.settingName = this.settingName;
      setting.settingsJSON = JSON.stringify(t);
      setting.userId = this.auth.loggedInUser.id;
      this.userSettingsService.SaveUserSetting(setting, false);
    }
  }

  private getPaginationIncrementSetting(): UserSetting {
    if (this.userSettingsService.userSettings) {
      return this.userSettingsService.userSettings.find(s => s.settingName === this.settingName);
    }

    return null;
  }
}
